import React from "react";
import SoftBox from "components/SoftBox";

const ApnaSelect = ({ options, value, name, onChange, origin, required, disabled }) => {

  return (
    <>
      <SoftBox >
        <select
          required={required}
          // className="select Category"
          className="glassmorphism-card"
          style={{ padding: "10px", width: "100%", borderRadius: "10px" }}
          name={name}
          onChange={onChange}
          value={value}
          disabled={disabled}
        >
          <option value="default">All</option>
          {options && options.length && options.map((elm, i) => {
            return (
              <>
                <option value={elm?._id || elm?.name}>{elm?.name || `location-${i}`}</option>
              </>
            );
          })}
        </select>
      </SoftBox>
    </>
  );
};

export default ApnaSelect;
